import { useQuery, useQueryClient } from "@tanstack/react-query";
import { mediaReviewOf, setMediaReview } from "@/api/admits-seva-album";

/** "Check every photo and video first": shown to the event's organisers only. */
export function MediaReviewToggle({ eventId }: { eventId: string }) {
  const qc = useQueryClient();
  const { data: mode } = useQuery({ queryKey: ["media-review", eventId], queryFn: () => mediaReviewOf(eventId) });
  if (mode === null || mode === undefined) return null;
  return (
    <label className="text-xs text-gray-600 flex gap-2 items-center">
      <input
        type="checkbox"
        checked={mode === "host"}
        onChange={async (e) => {
          await setMediaReview(eventId, e.target.checked ? "host" : "auto");
          await qc.invalidateQueries({ queryKey: ["media-review", eventId] });
        }}
      />
      Check every photo and video first
    </label>
  );
}
